<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="chapter" id="tab">
<p class="ctfm"><a href="#/eerbauckham0005#rtab">Tables</a></p>
<p class="toc1"><a href="#/eerbauckham0011#tab01" id="rtab01">1. Anonymous and Named Persons in Mark</a></p>
<p class="toc1"><a href="#/eerbauckham0011#tab02" id="rtab02">2. Anonymous and Named Persons in Luke</a></p>
<p class="toc1"><a href="#/eerbauckham0011#tab03" id="rtab03">3. Anonymous and Named Persons in Matthew</a></p>
<p class="toc1"><a href="#/eerbauckham0011#tab04" id="rtab04">4. Anonymous and Named Persons in John</a></p>
<p class="toc1"><a href="#/eerbauckham0011#tab05" id="rtab05">5. Names in the Four Gospels</a></p>
<p class="toc1"><a href="#/eerbauckham0012#tab06" id="rtab06">6. The 99 Most Popular Male Names among Palestinian Jews, 330 <span class="small">BCE</span>–200 <span class="small">CE</span></a></p>
<p class="toc1"><a href="#/eerbauckham0012#tab07" id="rtab07">7. The 31 Most Popular Female Names among Palestinian Jews, 330 <span class="small">BCE</span>–200 <span class="small">CE</span></a></p>
<p class="toc1"><a href="#/eerbauckham0012#tab08" id="rtab08">8. Index of Palestinian Jewish Male Names in the Gospels and Acts</a></p>
<p class="toc1"><a href="#/eerbauckham0012#tab09" id="rtab09">9. Index of Palestinian Jewish Female Names in the Gospels and Acts</a></p>
<p class="toc1"><a href="#/eerbauckham0013#tab10" id="rtab10">10. The Names of the Twelve</a></p>
<p class="toc1"><a href="#/eerbauckham0014#tab11" id="rtab11">11. Named Persons in the Gospel of Mark</a></p>
<p class="toc1"><a href="#/eerbauckham0014#tab12" id="rtab12">12. Named Persons in Lucian’s <em>Alexander</em></a></p>
<p class="toc1"><a href="#/eerbauckham0014#tab13" id="rtab13">13. Named Persons in Porphyry’s <em>Life of Plotinus</em></a></p>
<p class="toc1"><a href="#/eerbauckham0015#tab14" id="rtab14">14. The Plural-to-Singular Narrative Device in the Synoptic Gospels</a></p>
<p class="toc1"><a href="#/eerbauckham0015#tab15" id="rtab15">15. The Plural-to-Singular Narrative Device and References to Peter in the Gospel of Mark</a></p>
<p class="toc1"><a href="#/eerbauckham0025#tab16" id="rtab16">16. Named Apostles in Irenaeus</a></p>
<p class="toc1"><a href="#/eerbauckham0025#tab17" id="rtab17">17. Sources of Irenaeus’s Knowledge of John the Disciple of the Lord</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-bauckham-0006.vue?858e05e0